export default {
    url: '/power',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 803,
        title: 'Power Per Dollar',
        role: 'economics',
    },
};
